import { DashboardHeader, SideImageCard, UiButton } from "@/components";
import { CampagneForm } from "@/components/molecules";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function NouvelCampagne() {
  const navigate = useNavigate();

  return (
    <>
      <DashboardHeader subTitle="Bienvenue aux campagnes" />

      <div className="py-4">
        <SideImageCard imgSrc="/assets/images/chris-lee-70l1tDAI6rM-unsplash 1.png">
          <div className="">
            <UiButton
              variant="text"
              onClick={() => navigate(-1)}
              startIcon={<ArrowLeft />}
            >
              Retour
            </UiButton>

            <CampagneForm />
          </div>
        </SideImageCard>
      </div>
    </>
  );
}
